export default {
    decmal: "^([+-]?)\\d*\\.\\d+$",
    decmal1: "^[1-9]\\d*.\\d*|0.\\d*[1-9]\\d*$",
    decmal2: "^-([1-9]\\d*.\\d*|0.\\d*[1-9]\\d*)$",
    decmal3: "^-?([1-9]\\d*.\\d*|0.\\d*[1-9]\\d*|0?.0+|0)$",
    decmal4: "^[1-9]\\d*.\\d*|0.\\d*[1-9]\\d*|0?.0+|0$",
    decmal5: "^(-([1-9]\\d*.\\d*|0.\\d*[1-9]\\d*))|0?.0+|0$",
    intege: "^-?[1-9]\\d*$",
    intege1: "^[1-9]\\d*$",
    intege2: "^-[1-9]\\d*$",
    num: "^([+-]?)\\d*\\.?\\d+$",
    num1: "^[1-9]\\d*|0$",
    num2: "^-[1-9]\\d*|0$",
    ascii: "^[\\x00-\\xFF]+$",
    chinese: "^[\\u4e00-\\u9fa5]+$",
    color: "^[a-fA-F0-9]{6}$",
    date: "^\\d{4}(\\-|\\/|\.)\\d{1,2}\\1\\d{1,2}$",
    email: "^\\w+((-\\w+)|(\\.\\w+))*\\@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$",
    idcard: "^[1-9]([0-9]{14}|[0-9]{17})$",
    ip4: "^(25[0-5]|2[0-4]\\d|[0-1]\\d{2}|[1-9]?\\d)\\.(25[0-5]|2[0-4]\\d|[0-1]\\d{2}|[1-9]?\\d)\\.(25[0-5]|2[0-4]\\d|[0-1]\\d{2}|[1-9]?\\d)\\.(25[0-5]|2[0-4]\\d|[0-1]\\d{2}|[1-9]?\\d)$",
    letter: "^[A-Za-z]+$",
    letter_l: "^[a-z]+$",
    letter_u: "^[A-Z]+$",
    mobile: "^(0?(13|19|15|18|14|17|16)[0-9]{9}|128\\d{4}1234|12[2-7]\\d{8}|\\d{2}\\-\\d{8})$",
    phone: "^((0\\d{2,3}-\\d{7,8})|(1\\d{10})|(\\d{2}\\-\\d{8}))$",
    notempty: "^\\S+$",
    password: "^.*[A-Za-z0-9\\w_-]+.*$",
    fullNumber: "^[0-9]+$",
    picture: "(.*)\\.(jpg|bmp|gif|ico|pcx|jpeg|tif|png|raw|tga)$",
    tel: "^[0-9\-()（）]{7,18}$",
    url: "^http[s]?:\\/\\/([\\w-]+\\.)+[\\w-]+([\\w-./?%&:]*)?$",
    username: "^[A-Za-z0-9_\\-\\u4e00-\\u9fa5]+$",
    deptname: "^[A-Za-z0-9_()（）\\-\\u4e00-\\u9fa5]+$",
    zipcode: "^\\d{6}$",
    realname: "^[A-Za-z\\u4e00-\\u9fa5]+$",
    letter_num_cn: "^[a-zA-Z0-9\\u4e00-\\u9fa5]+$",
    companyname: "^[A-Za-z0-9_()（）\\-\\u4e00-\\u9fa5]+$",
    companyaddr: "^[A-Za-z0-9_()（）\\#\\-\\u4e00-\\u9fa5]+$",
    companysite: "^http[s]?:\\/\\/([\\w-]+\\.)+[\\w-]+([\\w-./?%&#:]*)?$",
    pdf: "^.*\.pdf$",
    excel: "^.*\.(xls|xlsx|csv)$",
};
